module.exports = __webpack_public_path__ + "static/media/03.26010fed.mp3";